const name = 'quantidade-dropdown-item'
export default {
  name,

  components: { }, 

  props: { 
    opcao:{
        type:Object, 
        default:{}
    }
  },

  mounted () {
    let labelDesmontada = this.opcao.text.split('-')
    this.codigo = labelDesmontada[0]
    this.quantidade = labelDesmontada[1]
    this.preco = labelDesmontada[2]
    this.comissao = labelDesmontada[3]

  },

  updated () { },

  data () {
    return {
        codigo: '',
        quantidade: '',
        preco: '',
        comissao: '',
     }
  },

  methods: { },

  computed: { }, 

};